'use client';

import { c as _c } from "react/compiler-runtime";
import { classNames } from '@/util/utils';
import type React from 'react';
import styles from './button.module.css';
interface ButtonProps {
  className?: string;
  onClick(): void;
  children: React.ReactNode;
}
export default function Button(t0) {
  const $ = _c(6);
  const {
    className,
    onClick,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(className, styles.button);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== onClick || $[4] !== t1) {
    t2 = <button type="button" className={t1} onClick={onClick}>{children}</button>;
    $[2] = children;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}